export default __webpack_public_path__ + "static/media/hdfc.ef52d5b5.svg";